<template>
  <div style="height: 100%;overflow: auto;">
    <div style="display: flex;margin-bottom: 20px;">
      <el-input v-model="keyword" placeholder="用户昵称" style="width: 250px;"></el-input>
      <el-button type="primary" @click="submit" style="margin-left: 10px;">搜索</el-button>
    </div>
    <el-table :data="list" border stripe>
      <el-table-column label="ID" prop="id" width="80px"></el-table-column>
      <el-table-column label="头像">
        <template v-slot="scope">
          <div class="wx-user">
            <div class="avatarurl" :style="{ backgroundImage:'url('+scope.row.avatarurl+')' }"></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="昵称" prop="nickname"></el-table-column>
      <el-table-column label="手机号码" prop="phone"></el-table-column>
      <el-table-column label="性别" prop="">
        <template slot-scope="scope">{{scope.row.gender==1 ? '男' : (scope.row.gender==2 ? '女':'未知')}}</template>
      </el-table-column>
      <el-table-column label="创建时间" prop="addtime_format"></el-table-column>
      <el-table-column label="登陆时间" prop="lasttime_format"></el-table-column>
      <el-table-column label="操作">
        <template v-slot="scope">
<!--          <el-button type="primary" @click="admin_edit(scope.row.id)" size="small" style="margin-right: 10px;">编辑</el-button>-->
          <el-popconfirm title="确认删除？" @confirm="del(scope.row.id)">
            <el-button type="danger" size="small" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 60px;"></div>
    <layer-page :total="total" :currentPage="page" @change="page_change"></layer-page>
  </div>
</template>

<script>
import LayerPage from "@/components/layer-page";
export default {
name: "user",
  components:{LayerPage},
  data(){
    return{
      list:[],
      is_load:false,
      page:1,
      total:0,
      keyword:'',
    }
  },
  mounted : async function(){
    try{
      await this.get_list();
    }catch (e){
      console.log(e);
      return false;
    }
  },
  methods: {
    get_list: async function () {
      if (!this.is_load) {
        this.is_load = true;
        this.$_showLoading();
        let res = await this.$_api.user('get_list', {page: this.page,keyword:this.keyword});
        this.is_load = false;
        this.$_hideLoading();
        this.list = res.list;
        this.total = res.total;
      }
    },
    submit : async function  (){
      try{
        this.is_load = false;
        this.list = [];
        this.page = 1;
        this.total = 0;
        await this.get_list();
      }catch (e){
        console.log(e);
        return false;
      }
    },
    page_change : async function  (e){
      try{
        this.page = e;
        this.is_load = false;
        this.list = [];
        await this.get_list();
      }catch (e){
        console.log(e);
        return false;
      }
    },
  }
}
</script>

<style scoped>
.wx-user { display: flex; height: 40px; overflow-x: hidden; vertical-align: middle; line-height: 40px; }
.avatarurl { width: 40px; height: 40px; border-radius: 20px; overflow-x: hidden;background: #f2f2f2 no-repeat center; background-size: cover; }
.nickname { padding-left: 15px; font-size: 14px; line-height: 30px;flex: 1 }
</style>